/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum SubscriptionStatus {
  Active = "active",
  Canceled = "canceled",
  PastDue = "past_due",
  Unpaid = "unpaid",
  Trialing = "trialing",
}

export enum PlanType {
  Free = "free",
  Local = "local",
  Regional = "regional",
  National = "national",
}

export enum SportType {
  Rugby = "rugby",
  Football = "football",
  Basketball = "basketball",
  Tennis = "tennis",
  Other = "other",
}

export enum FootballStatus {
  Upcoming = "upcoming",
  FirstHalf = "first_half",
  HalfTime = "half_time",
  SecondHalf = "second_half",
  ExtraTime = "extra_time",
  Penalties = "penalties",
  Done = "done",
}

export enum RugbyStatus {
  Upcoming = "upcoming",
  FirstHalf = "first_half",
  HalfTime = "half_time",
  SecondHalf = "second_half",
  ExtraTime = "extra_time",
  Penalties = "penalties",
  Done = "done",
}

/** Construct a type with a set of properties K of type T */
export type RecordStringAny = Record<string, any>;

/** From T, pick a set of properties whose keys are in the union K */
export interface PickITeamExcludeKeysPersons {
  _id: string;
  config_id: string;
  name: string;
  logo_key?: string;
  category?: string;
  pool?: string;
  /** Construct a type with a set of properties K of type T */
  metadata?: RecordStringAny;
  contact?: {
    phone_number?: string;
    email?: string;
    lastname?: string;
    firstname?: string;
  };
  checkout_intent_id?: string;
  order_id?: string;
  validated?: boolean;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

/** Construct a type with the properties of T except for those in type K. */
export type OmitITeamPersons = PickITeamExcludeKeysPersons;

export type MongooseTypesObjectId = string;

/** Construct a type with a set of properties K of type T */
export type RecordStringNumber = Record<string, number>;

export interface IPerson {
  _id: string;
  config_id: string;
  team?: MongooseTypesObjectId;
  firstname: string;
  lastname: string;
  image_key?: string;
  /** @format double */
  number?: number;
  /** Construct a type with a set of properties K of type T */
  metadata?: RecordStringAny;
  status?: "inscrit" | "invalide" | "valide";
  role?: "coach" | "manager" | "physio" | "assistant" | "player";
  actions?: MongooseTypesObjectId[];
  /** Construct a type with a set of properties K of type T */
  stats?: RecordStringNumber;
  home_games?: MongooseTypesObjectId[];
  away_games?: MongooseTypesObjectId[];
  actions_sub_on?: MongooseTypesObjectId[];
  full_name?: string;
  /** @format double */
  points?: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

export type GetTeamResponse = OmitITeamPersons & {
  stats?: {
    /** @format double */
    points_taken?: number;
    /** @format double */
    points_scored?: number;
  };
  persons: IPerson[];
};

export interface CreateTeam {
  name: string;
  logo_key?: string;
  category?: string;
  pool?: string;
  persons?: MongooseTypesObjectId[];
  responsible_first_name?: string;
  responsible_last_name?: string;
  affiliation_ffr?: string;
  email?: string;
  phone_number?: string;
  automatic_registration?: boolean;
  registration_pdf?: string;
  checkout_intent_id?: string;
  order_id?: string;
  validated?: boolean;
  /** @format double */
  url?: number;
}

/** Make all properties in T optional */
export interface PartialCreateTeam {
  name?: string;
  logo_key?: string;
  category?: string;
  pool?: string;
  persons?: MongooseTypesObjectId[];
  responsible_first_name?: string;
  responsible_last_name?: string;
  affiliation_ffr?: string;
  email?: string;
  phone_number?: string;
  automatic_registration?: boolean;
  registration_pdf?: string;
  checkout_intent_id?: string;
  order_id?: string;
  validated?: boolean;
  /** @format double */
  url?: number;
}

export type UpdateTeam = PartialCreateTeam;

export interface PlayerStatsResponse {
  _id: string;
  firstname: string;
  lastname: string;
  full_name: string;
  team: string;
  /** @format double */
  tries: number;
  /** @format double */
  conversions: number;
  /** @format double */
  penalties: number;
  /** @format double */
  drops: number;
  /** @format double */
  points: number;
  image_key: string;
  team_logo_key: string;
  /** @format double */
  number: number;
}

export interface TeamStatsResponse {
  _id: string;
  name: string;
  logo_key: string;
  /** @format double */
  points_scored: number;
  /** @format double */
  points_taken: number;
}

export interface ISponsor {
  _id: string;
  config_id: string;
  name: string;
  description?: string;
  logo_key?: string;
  website?: string;
  /** @format double */
  order: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

/** Make all properties in T optional */
export interface PartialOmitISponsorIdOrConfigIdOrCreatedAtOrUpdatedAtOrNameOrOrder {
  logo_key?: string;
  description?: string;
  website?: string;
}

export type CreateSponsor =
  PartialOmitISponsorIdOrConfigIdOrCreatedAtOrUpdatedAtOrNameOrOrder & {
    /** @format double */
    order: number;
    name: string;
  };

/** Make all properties in T optional */
export interface PartialOmitISponsorIdOrConfigIdOrCreatedAtOrUpdatedAt {
  name?: string;
  logo_key?: string;
  /** @format double */
  order?: number;
  description?: string;
  website?: string;
}

export type UpdateSponsor =
  PartialOmitISponsorIdOrConfigIdOrCreatedAtOrUpdatedAt;

export interface PlayoffTeamPlaceholder {
  /** @format double */
  position: number;
  pool_id?: string;
  pool_name?: string;
  description: string;
  is_global_ranking?: boolean;
  /** @format double */
  global_position?: number;
  /** @format double */
  global_rank?: number;
}

export interface IGame {
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  createdAt: string;
  channel_id?: string;
  chrono_id?: string;
  signature_file_key?: string;
  category?: string;
  pool: string;
  status_detailed: RugbyStatus | FootballStatus;
  status: "upcoming" | "live" | "done";
  draw: boolean;
  /** @format date-time */
  end_time: string | null;
  /** @format date-time */
  start_time: string | null;
  /** @format date-time */
  date: string;
  /** @format double */
  manual_away_score?: number;
  /** @format double */
  manual_home_score?: number;
  manual_score_override?: boolean;
  /** @format double */
  away_score?: number;
  /** @format double */
  home_score?: number;
  game_period: string;
  away_lineup: MongooseTypesObjectId[];
  home_lineup: MongooseTypesObjectId[];
  actions: MongooseTypesObjectId[];
  away_team_placeholder?: string;
  home_team_placeholder?: string;
  away_team_signature_file_key?: string;
  away_team: MongooseTypesObjectId;
  home_team_signature_file_key?: string;
  home_team: MongooseTypesObjectId;
  field?: MongooseTypesObjectId;
  phase: MongooseTypesObjectId;
  config_id: string;
  _id: string;
}

export interface TeamStanding {
  team_id: string;
  team_name: string;
  team_logo_key?: string;
  pool: string;
  /** @format double */
  games_played?: number;
  /** @format double */
  games_won?: number;
  /** @format double */
  games_drawn?: number;
  /** @format double */
  games_lost?: number;
  /** @format double */
  points_scored?: number;
  /** @format double */
  points_conceded?: number;
  /** @format double */
  points_difference?: number;
  /** @format double */
  points?: number;
  /** @format double */
  rank?: number;
}

export interface PoolStanding {
  pool_id: string;
  pool_name: string;
  teams: TeamStanding[];
}

export interface PhaseResponse {
  _id: string;
  config_id: string;
  name: string;
  type: "regular" | "playoff" | "final";
  playoff_type?: "bracket" | "round_robin";
  categories?: string[];
  pools?: {
    playoff_placeholders?: PlayoffTeamPlaceholder[];
    teams?: string[];
    name: string;
    id: string;
  }[];
  games: IGame[];
  standings?: PoolStanding[];
  linked_phase_id?: string;
  auto_assignment_enabled?: boolean;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

export interface CreateOrUpdatePhaseRequest {
  name: string;
  type: "regular" | "playoff" | "final";
  playoff_type?: "bracket" | "round_robin";
  pools?: {
    playoff_placeholders?: PlayoffTeamPlaceholder[];
    teams?: string[];
    name: string;
    id: string;
  }[];
  categories?: string[];
  games?: string[];
  linked_phase_id?: string;
  auto_assignment_enabled?: boolean;
}

export interface CreatePlayoffPhaseRequest {
  name: string;
  linked_phase_id: string;
  playoff_type?: "bracket" | "round_robin";
  pools: {
    playoff_placeholders: PlayoffTeamPlaceholder[];
    name: string;
    id: string;
  }[];
  categories?: string[];
  auto_assignment_enabled?: boolean;
}

/** From T, pick a set of properties whose keys are in the union K */
export interface PickIPersonExcludeKeysTeamOrActionsOrHomeGamesOrAwayGamesOrActionsSubOn {
  /** @format double */
  number?: number;
  _id: string;
  config_id: string;
  /** Construct a type with a set of properties K of type T */
  metadata?: RecordStringAny;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  firstname: string;
  lastname: string;
  image_key?: string;
  status?: "inscrit" | "invalide" | "valide";
  role?: "coach" | "manager" | "physio" | "assistant" | "player";
  /** Construct a type with a set of properties K of type T */
  stats?: RecordStringNumber;
  full_name?: string;
  /** @format double */
  points?: number;
}

/** Construct a type with the properties of T except for those in type K. */
export type OmitIPersonTeamOrActionsOrHomeGamesOrAwayGamesOrActionsSubOn =
  PickIPersonExcludeKeysTeamOrActionsOrHomeGamesOrAwayGamesOrActionsSubOn;

export interface ITeam {
  _id: string;
  config_id: string;
  name: string;
  logo_key?: string;
  category?: string;
  pool?: string;
  persons?: MongooseTypesObjectId[];
  /** Construct a type with a set of properties K of type T */
  metadata?: RecordStringAny;
  contact?: {
    phone_number?: string;
    email?: string;
    lastname?: string;
    firstname?: string;
  };
  checkout_intent_id?: string;
  order_id?: string;
  validated?: boolean;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

export interface IAction {
  _id: string;
  config_id: string;
  game: MongooseTypesObjectId;
  player?: MongooseTypesObjectId;
  player_on?: MongooseTypesObjectId;
  team: MongooseTypesObjectId;
  type: string;
  /** @format double */
  time: number;
  /** Construct a type with a set of properties K of type T */
  metadata?: RecordStringAny;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

export type GetPersonResponse =
  OmitIPersonTeamOrActionsOrHomeGamesOrAwayGamesOrActionsSubOn & {
    actions_sub_on: IAction[];
    away_games: IGame[];
    home_games: IGame[];
    actions: IAction[];
    team: ITeam;
  };

export interface PaginatedResponseGetPersonResponse {
  data: GetPersonResponse[];
  pagination: {
    /** @format double */
    prevPage: number | null;
    /** @format double */
    nextPage: number | null;
    hasPrevPage: boolean;
    hasNextPage: boolean;
    /** @format double */
    totalPages: number;
    /** @format double */
    totalCount: number;
    /** @format double */
    pageSize: number;
    /** @format double */
    currentPage: number;
  };
}

export interface CreatePerson {
  role?: "coach" | "manager" | "physio" | "assistant" | "player";
  status?: "inscrit" | "invalide" | "valide";
  /** Construct a type with a set of properties K of type T */
  metadata?: RecordStringAny;
  /** @format double */
  number?: number;
  image_key?: string;
  team?: MongooseTypesObjectId;
  lastname: string;
  firstname: string;
}

/** Make all properties in T optional */
export interface PartialCreatePerson {
  firstname?: string;
  lastname?: string;
  team?: MongooseTypesObjectId;
  image_key?: string;
  /** @format double */
  number?: number;
  /** Construct a type with a set of properties K of type T */
  metadata?: RecordStringAny;
  status?: "inscrit" | "invalide" | "valide";
  role?: "coach" | "manager" | "physio" | "assistant" | "player";
}

export type UpdatePerson = PartialCreatePerson;

export interface IManager {
  _id: string;
  firstname: string;
  lastname: string;
  email: string;
  phone: string;
  image_key?: string;
  sso_user_id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

export interface CreateManager {
  firstname: string;
  lastname: string;
  email: string;
  phone?: string;
  image_key?: string;
  sso_user_id: string;
}

/** Make all properties in T optional */
export interface PartialOmitCreateManagerSsoUserId {
  email?: string;
  firstname?: string;
  lastname?: string;
  image_key?: string;
  phone?: string;
}

export type UpdateManager = PartialOmitCreateManagerSsoUserId;

/** From T, pick a set of properties whose keys are in the union K */
export interface PickIGameExcludeKeysPhaseOrFieldOrHomeTeamOrAwayTeamOrActionsOrHomeLineupOrAwayLineup {
  _id: string;
  config_id: string;
  category?: string;
  pool: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  status: "upcoming" | "done" | "live";
  home_team_signature_file_key?: string;
  away_team_signature_file_key?: string;
  home_team_placeholder?: string;
  away_team_placeholder?: string;
  game_period: string;
  /** @format double */
  home_score?: number;
  /** @format double */
  away_score?: number;
  manual_score_override?: boolean;
  /** @format double */
  manual_home_score?: number;
  /** @format double */
  manual_away_score?: number;
  /** @format date-time */
  date: string;
  /** @format date-time */
  start_time: string;
  /** @format date-time */
  end_time: string;
  draw: boolean;
  status_detailed:
    | "upcoming"
    | "first_half"
    | "half_time"
    | "second_half"
    | "extra_time"
    | "penalties"
    | "done";
  signature_file_key?: string;
  chrono_id?: string;
  channel_id?: string;
}

/** Construct a type with the properties of T except for those in type K. */
export type OmitIGamePhaseOrFieldOrHomeTeamOrAwayTeamOrActionsOrHomeLineupOrAwayLineup =
  PickIGameExcludeKeysPhaseOrFieldOrHomeTeamOrAwayTeamOrActionsOrHomeLineupOrAwayLineup;

/** From T, pick a set of properties whose keys are in the union K */
export interface PickPhaseResponseExcludeKeysTeamsOrGamesOrStandingsOrLinkedPhaseId {
  _id: string;
  config_id: string;
  name: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  type: "regular" | "playoff" | "final";
  playoff_type?: "bracket" | "round_robin";
  categories?: string[];
  pools?: {
    playoff_placeholders?: PlayoffTeamPlaceholder[];
    teams?: string[];
    name: string;
    id: string;
  }[];
  auto_assignment_enabled?: boolean;
}

export interface IPhase {
  _id: string;
  config_id: string;
  name: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  type: "regular" | "playoff" | "final";
  playoff_type?: "bracket" | "round_robin";
  categories?: string[];
  pools?: {
    playoff_placeholders?: PlayoffTeamPlaceholder[];
    teams?: string[];
    name: string;
    id: string;
  }[];
  auto_assignment_enabled?: boolean;
  teams: {
    stats: {
      /** @format double */
      points_difference: number;
      /** @format double */
      points_conceded: number;
      /** @format double */
      points_scored: number;
      /** @format double */
      games_lost: number;
      /** @format double */
      games_drawn: number;
      /** @format double */
      games_won: number;
      /** @format double */
      games_played: number;
    };
    away_games: MongooseTypesObjectId[];
    home_games: MongooseTypesObjectId[];
    actions: MongooseTypesObjectId[];
    id: MongooseTypesObjectId;
  }[];
  games: MongooseTypesObjectId[];
  standings?: PoolStanding[];
  linked_phase_id?: MongooseTypesObjectId;
}

export interface IField {
  _id: string;
  config_id: string;
  name: string;
  location?: string;
  image_key?: string;
  description?: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

export type GetGameResponse =
  OmitIGamePhaseOrFieldOrHomeTeamOrAwayTeamOrActionsOrHomeLineupOrAwayLineup & {
    loser: ITeam | null;
    winner: ITeam | null;
    actions: IAction[];
    away_lineup: IPerson[];
    home_lineup: IPerson[];
    away_team?: ITeam;
    home_team?: ITeam;
    field?: IField;
    phase: IPhase;
  };

export interface CreateGameRequest {
  away_team_placeholder?: string;
  home_team_placeholder?: string;
  /** @format double */
  manual_away_score?: number;
  /** @format double */
  manual_home_score?: number;
  manual_score_override?: boolean;
  /** @format date-time */
  end_time?: string | null;
  /** @format date-time */
  start_time?: string | null;
  away_team_signature_file_key?: string;
  home_team_signature_file_key?: string;
  chrono_id?: string;
  status_detailed?: RugbyStatus | FootballStatus;
  status?: "upcoming" | "live" | "done";
  category?: string;
  /** @format date-time */
  date?: string;
  pool: string;
  field?: MongooseTypesObjectId;
  away_team?: MongooseTypesObjectId;
  home_team?: MongooseTypesObjectId;
  phase: MongooseTypesObjectId;
}

/** Make all properties in T optional */
export interface PartialCreateGameRequest {
  phase?: MongooseTypesObjectId;
  home_team?: MongooseTypesObjectId;
  away_team?: MongooseTypesObjectId;
  field?: MongooseTypesObjectId;
  pool?: string;
  /** @format date-time */
  date?: string;
  category?: string;
  status?: "upcoming" | "done" | "live";
  status_detailed?:
    | "upcoming"
    | "first_half"
    | "half_time"
    | "second_half"
    | "extra_time"
    | "penalties"
    | "done";
  chrono_id?: string;
  home_team_signature_file_key?: string;
  away_team_signature_file_key?: string;
  /** @format date-time */
  start_time?: string;
  /** @format date-time */
  end_time?: string;
  manual_score_override?: boolean;
  /** @format double */
  manual_home_score?: number;
  /** @format double */
  manual_away_score?: number;
  home_team_placeholder?: string;
  away_team_placeholder?: string;
}

export type UpdateGameRequest = PartialCreateGameRequest;

export type UpdateGamesRequest = (UpdateGameRequest & {
  _id: string;
})[];

export interface FieldResponse {
  _id: string;
  config_id: string;
  name: string;
  location?: string;
  image_key?: string;
  description?: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

/** From T, pick a set of properties whose keys are in the union K */
export interface PickFieldResponseExcludeKeysIdOrConfigIdOrCreatedAtOrUpdatedAt {
  name: string;
  description?: string;
  image_key?: string;
  location?: string;
}

/** Construct a type with the properties of T except for those in type K. */
export type OmitFieldResponseIdOrConfigIdOrCreatedAtOrUpdatedAt =
  PickFieldResponseExcludeKeysIdOrConfigIdOrCreatedAtOrUpdatedAt;

export type CreateFieldRequest =
  OmitFieldResponseIdOrConfigIdOrCreatedAtOrUpdatedAt;

/** Make all properties in T optional */
export interface PartialCreateFieldRequest {
  name?: string;
  description?: string;
  image_key?: string;
  location?: string;
}

export type UpdateFieldRequest = PartialCreateFieldRequest;

export interface ISubscriptionPlan {
  plan_type: PlanType;
  stripe_price_id?: string;
  stripe_subscription_id?: string;
  stripe_customer_id?: string;
  status: SubscriptionStatus;
  /** @format date-time */
  current_period_start?: string;
  /** @format date-time */
  current_period_end?: string;
  cancel_at_period_end?: boolean;
  features: {
    mobile_responsive?: boolean;
    real_time_updates?: boolean;
    payment_collection?: boolean;
    on_site_support?: boolean;
    custom_tables?: boolean;
    multi_day_support?: boolean;
    custom_integrations?: boolean;
    white_label?: boolean;
    api_access?: boolean;
    priority_support?: boolean;
    custom_branding?: boolean;
    advanced_analytics?: boolean;
    /** @format double */
    max_games?: number;
    /** @format double */
    max_players?: number;
    /** @format double */
    max_teams?: number;
  };
  /** Construct a type with a set of properties K of type T */
  metadata?: RecordStringAny;
}

export interface IConfig {
  _id: string;
  name: string;
  slug: string;
  logo_key?: string;
  sport_type: SportType;
  hosting_club?: string;
  sport_settings?: {
    draw_strategy: string[];
    statistics: {
      associated_key?: string;
      label: string;
      name: string;
    }[];
    standings: {
      /** @format double */
      loss: number;
      /** @format double */
      draw: number;
      /** @format double */
      win: number;
    };
    phases: {
      /** @format double */
      duration: number;
      name: string;
    }[];
    actions: {
      /** Construct a type with a set of properties K of type T */
      metadata_schema?: RecordStringAny;
      /** @format double */
      points: number;
      label: string;
      type: string;
    }[];
    name: string;
  };
  landing?: {
    altLink?: {
      text_color?: string;
      link?: string;
      title?: string;
    };
    secondaryButton?: {
      text_color?: string;
      background_color?: string;
      link?: string;
      title?: string;
    };
    mainButton?: {
      text_color?: string;
      background_color?: string;
      link?: string;
      title?: string;
    };
    accent_color?: string;
    pages?: ("teams" | "rankings" | "games" | "fields" | "stats")[];
    video_key?: string;
    background_image_key?: string;
    description?: string;
    end_date?: string;
    start_date?: string;
    title_line2?: string;
    title?: string;
  };
  is_live?: boolean;
  show_phase_selector?: boolean;
  current_phase?: MongooseTypesObjectId;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  manager_ids: MongooseTypesObjectId[];
  subscription_plan?: ISubscriptionPlan;
  helloasso?: {
    organization_id?: string;
    /** @format date-time */
    refresh_token_expires_at?: string;
    refresh_token?: string;
    /** @format date-time */
    token_expires_at?: string;
    access_token?: string;
    connected?: boolean;
  };
}

/** Make all properties in T required */
export type RequiredIdString = object;

export interface CreateConfig {
  name: string;
  sport_type: string;
  hosting_club?: string;
  logo_key?: string;
  landing?: {
    video_key?: string;
    background_image_key?: string;
    description?: string;
    accent_color?: string;
    end_date?: string;
    start_date?: string;
    title_line2?: string;
    title?: string;
  };
  main_manager: {
    sso_user_id?: string;
    image_key?: string;
    phone?: string;
    email: string;
    lastname: string;
    firstname: string;
  };
  other_managers_emails?: string[];
  fields?: string[];
  phases?: {
    pools: {
      teams: string[];
      name: string;
    }[];
    type: string;
    name: string;
  }[];
}

/** Make all properties in T optional */
export interface PartialOmitIConfigIdOrConfigIdOrCreatedAtOrUpdatedAt {
  name?: string;
  logo_key?: string;
  slug?: string;
  sport_type?: "rugby" | "football" | "basketball" | "tennis" | "other";
  hosting_club?: string;
  sport_settings?: {
    draw_strategy: string[];
    statistics: {
      associated_key?: string;
      label: string;
      name: string;
    }[];
    standings: {
      /** @format double */
      loss: number;
      /** @format double */
      draw: number;
      /** @format double */
      win: number;
    };
    phases: {
      /** @format double */
      duration: number;
      name: string;
    }[];
    actions: {
      /** Construct a type with a set of properties K of type T */
      metadata_schema?: RecordStringAny;
      /** @format double */
      points: number;
      label: string;
      type: string;
    }[];
    name: string;
  };
  landing?: {
    altLink?: {
      text_color?: string;
      link?: string;
      title?: string;
    };
    secondaryButton?: {
      text_color?: string;
      background_color?: string;
      link?: string;
      title?: string;
    };
    mainButton?: {
      text_color?: string;
      background_color?: string;
      link?: string;
      title?: string;
    };
    accent_color?: string;
    pages?: ("stats" | "teams" | "games" | "fields" | "rankings")[];
    video_key?: string;
    background_image_key?: string;
    description?: string;
    end_date?: string;
    start_date?: string;
    title_line2?: string;
    title?: string;
  };
  is_live?: boolean;
  show_phase_selector?: boolean;
  current_phase?: MongooseTypesObjectId;
  manager_ids?: MongooseTypesObjectId[];
  subscription_plan?: ISubscriptionPlan;
  helloasso?: {
    organization_id?: string;
    /** @format date-time */
    refresh_token_expires_at?: string;
    refresh_token?: string;
    /** @format date-time */
    token_expires_at?: string;
    access_token?: string;
    connected?: boolean;
  };
}

export interface IBackupData {
  config: IConfig;
  phases: IPhase[];
  teams: ITeam[];
  fields: IField[];
  games: IGame[];
  persons: IPerson[];
  sponsors: ISponsor[];
  actions: IAction[];
}

export interface IBackup {
  _id: string;
  config_id: string;
  name: string;
  description?: string;
  data: IBackupData;
  /** @format date-time */
  created_at: string;
  created_by: string;
  version: string;
}

export interface CreateBackupRequest {
  name: string;
  description?: string;
}

export interface RestoreBackupRequest {
  backup_id: string;
  restore_name?: string;
}

export interface GeneratedGame {
  phase: string;
  home_team: string;
  away_team: string;
  field?: string;
  date: string;
  pool: string;
  status: "upcoming";
}

export interface GenerateGamesResponse {
  games: GeneratedGame[];
  schedule: {
    endDate: string;
    startDate: string;
    /** @format double */
    totalDays: number;
    /** @format double */
    totalGames: number;
  };
}

export interface ErrorResponse {
  error: string;
  details?: string;
}

export interface GenerateGamesRequest {
  startDate: string;
  startTime: string;
  /** @format double */
  gameDuration: number;
  /** @format double */
  restTimeInterval: number;
  /** @format double */
  minimumRestTime: number;
  additionalInstructions: string;
  fields: {
    games: {
      pool: string;
      date?: string;
      away_team: string;
      home_team: string;
    }[];
    name: string;
  }[];
}

export interface ScheduledGame {
  id: string;
  home_team: string;
  away_team: string;
  date: string;
}

export interface ScheduleGamesResponse {
  scheduledGames: ScheduledGame[];
}

export interface ScheduleGamesRequest {
  fields: {
    games: {
      pool: string;
      date?: string;
      away_team: string;
      home_team: string;
    }[];
    name: string;
  }[];
  startDate: string;
  startTime: string;
  /** @format double */
  gameDuration: number;
  /** @format double */
  restTime: number;
}

/** From T, pick a set of properties whose keys are in the union K */
export interface PickIActionExcludeKeysGameOrPlayerOrPlayerOnOrTeam {
  _id: string;
  config_id: string;
  /** Construct a type with a set of properties K of type T */
  metadata?: RecordStringAny;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  type: string;
  /** @format double */
  time: number;
}

/** Construct a type with the properties of T except for those in type K. */
export type OmitIActionGameOrPlayerOrPlayerOnOrTeam =
  PickIActionExcludeKeysGameOrPlayerOrPlayerOnOrTeam;

export type GetActionResponse = OmitIActionGameOrPlayerOrPlayerOnOrTeam & {
  /** @format double */
  points: number;
  team: ITeam;
  player_on?: IPerson;
  player?: IPerson;
  game: IGame;
};

/** From T, pick a set of properties whose keys are in the union K */
export interface PickIActionExcludeKeysIdOrConfigIdOrCreatedAtOrUpdatedAt {
  /** Construct a type with a set of properties K of type T */
  metadata?: RecordStringAny;
  team: MongooseTypesObjectId;
  player?: MongooseTypesObjectId;
  type: string;
  game: MongooseTypesObjectId;
  player_on?: MongooseTypesObjectId;
  /** @format double */
  time: number;
}

/** Construct a type with the properties of T except for those in type K. */
export type OmitIActionIdOrConfigIdOrCreatedAtOrUpdatedAt =
  PickIActionExcludeKeysIdOrConfigIdOrCreatedAtOrUpdatedAt;

export type CreateAction = OmitIActionIdOrConfigIdOrCreatedAtOrUpdatedAt;

/** Make all properties in T optional */
export interface PartialCreateAction {
  /** Construct a type with a set of properties K of type T */
  metadata?: RecordStringAny;
  team?: MongooseTypesObjectId;
  player?: MongooseTypesObjectId;
  type?: string;
  game?: MongooseTypesObjectId;
  player_on?: MongooseTypesObjectId;
  /** @format double */
  time?: number;
}

/** From T, pick a set of properties whose keys are in the union K */
export interface PickCreateActionExcludeKeysGame {
  /** Construct a type with a set of properties K of type T */
  metadata?: RecordStringAny;
  team: MongooseTypesObjectId;
  player?: MongooseTypesObjectId;
  type: string;
  player_on?: MongooseTypesObjectId;
  /** @format double */
  time: number;
}

/** Construct a type with the properties of T except for those in type K. */
export type OmitCreateActionGame = PickCreateActionExcludeKeysGame;

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
  extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "/";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(
      (key) => "undefined" !== typeof query[key],
    );
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key),
      )
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.JsonApi]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== "string"
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) => {
      if (input instanceof FormData) {
        return input;
      }

      return Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData());
    },
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams,
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (
    cancelToken: CancelToken,
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(
      `${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { "Content-Type": type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === "undefined" || body === null
            ? null
            : payloadFormatter(body),
      },
    ).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const responseToParse = responseFormat ? response.clone() : response;
      const data = !responseFormat
        ? r
        : await responseToParse[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title tournoi-ai-api
 * @version 1.0.0
 * @license ISC
 * @baseUrl /
 * @contact
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  teams = {
    /**
     * @description Get all teams for a specific config
     *
     * @tags Teams & Registrations
     * @name GetTeams
     * @request GET:/teams
     */
    getTeams: (params: RequestParams = {}) =>
      this.request<GetTeamResponse[], any>({
        path: `/teams`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new team
     *
     * @tags Teams & Registrations
     * @name CreateTeam
     * @request POST:/teams
     */
    createTeam: (data: CreateTeam, params: RequestParams = {}) =>
      this.request<GetTeamResponse, any>({
        path: `/teams`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete multiple teams
     *
     * @tags Teams & Registrations
     * @name DeleteTeams
     * @request DELETE:/teams
     */
    deleteTeams: (data: string[], params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/teams`,
        method: "DELETE",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Get a team by id (scoped to config)
     *
     * @tags Teams & Registrations
     * @name GetTeam
     * @request GET:/teams/{id}
     */
    getTeam: (id: string, params: RequestParams = {}) =>
      this.request<GetTeamResponse, any>({
        path: `/teams/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Update a team
     *
     * @tags Teams & Registrations
     * @name UpdateTeam
     * @request PUT:/teams/{id}
     */
    updateTeam: (id: string, data: UpdateTeam, params: RequestParams = {}) =>
      this.request<GetTeamResponse, any>({
        path: `/teams/${id}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete a team
     *
     * @tags Teams & Registrations
     * @name DeleteTeam
     * @request DELETE:/teams/{id}
     */
    deleteTeam: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/teams/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Get teams by category (scoped to config)
     *
     * @tags Teams & Registrations
     * @name GetTeamsByCategory
     * @request GET:/teams/category/{category}
     */
    getTeamsByCategory: (category: string, params: RequestParams = {}) =>
      this.request<GetTeamResponse[], any>({
        path: `/teams/category/${category}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Get teams by pool (scoped to config)
     *
     * @tags Teams & Registrations
     * @name GetTeamsByPool
     * @request GET:/teams/pool/{pool}
     */
    getTeamsByPool: (pool: string, params: RequestParams = {}) =>
      this.request<GetTeamResponse[], any>({
        path: `/teams/pool/${pool}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Get validated teams
     *
     * @tags Teams & Registrations
     * @name GetValidatedTeams
     * @request GET:/teams/validated
     */
    getValidatedTeams: (params: RequestParams = {}) =>
      this.request<GetTeamResponse[], any>({
        path: `/teams/validated`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Get pending teams (not validated)
     *
     * @tags Teams & Registrations
     * @name GetPendingTeams
     * @request GET:/teams/pending
     */
    getPendingTeams: (params: RequestParams = {}) =>
      this.request<GetTeamResponse[], any>({
        path: `/teams/pending`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Validate a team registration
     *
     * @tags Teams & Registrations
     * @name ValidateTeam
     * @request PUT:/teams/{id}/validate
     */
    validateTeam: (id: string, params: RequestParams = {}) =>
      this.request<GetTeamResponse, any>({
        path: `/teams/${id}/validate`,
        method: "PUT",
        format: "json",
        ...params,
      }),

    /**
     * @description Add person to team (scoped to config)
     *
     * @tags Teams & Registrations
     * @name AddPersonToTeam
     * @request POST:/teams/{id}/persons
     */
    addPersonToTeam: (
      id: string,
      data: {
        personId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetTeamResponse, any>({
        path: `/teams/${id}/persons`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Remove person from team (scoped to config)
     *
     * @tags Teams & Registrations
     * @name RemovePersonFromTeam
     * @request DELETE:/teams/{id}/persons/{personId}
     */
    removePersonFromTeam: (
      id: string,
      personId: string,
      params: RequestParams = {},
    ) =>
      this.request<GetTeamResponse, any>({
        path: `/teams/${id}/persons/${personId}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),
  };
  stats = {
    /**
     * @description Get players sorted by specific stat
     *
     * @tags Stats
     * @name GetPlayersByStats
     * @request GET:/stats/players
     */
    getPlayersByStats: (
      query: {
        stat: "tries" | "conversions" | "penalties" | "drops" | "points";
      },
      params: RequestParams = {},
    ) =>
      this.request<PlayerStatsResponse[], any>({
        path: `/stats/players`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Get teams sorted by specific stat
     *
     * @tags Stats
     * @name GetTeamsByStats
     * @request GET:/stats/teams
     */
    getTeamsByStats: (
      query: {
        stat: "points_scored" | "points_taken";
        phaseId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TeamStatsResponse[], any>({
        path: `/stats/teams`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  };
  sponsors = {
    /**
     * @description Get all sponsors
     *
     * @tags Sponsors
     * @name GetSponsors
     * @request GET:/sponsors
     */
    getSponsors: (params: RequestParams = {}) =>
      this.request<ISponsor[], any>({
        path: `/sponsors`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new sponsor
     *
     * @tags Sponsors
     * @name CreateSponsor
     * @request POST:/sponsors
     */
    createSponsor: (data: CreateSponsor, params: RequestParams = {}) =>
      this.request<ISponsor, any>({
        path: `/sponsors`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get a sponsor by id
     *
     * @tags Sponsors
     * @name GetSponsor
     * @request GET:/sponsors/{id}
     */
    getSponsor: (id: string, params: RequestParams = {}) =>
      this.request<ISponsor, any>({
        path: `/sponsors/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Update a sponsor
     *
     * @tags Sponsors
     * @name UpdateSponsor
     * @request PUT:/sponsors/{id}
     */
    updateSponsor: (
      id: string,
      data: UpdateSponsor,
      params: RequestParams = {},
    ) =>
      this.request<ISponsor, any>({
        path: `/sponsors/${id}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete a sponsor
     *
     * @tags Sponsors
     * @name DeleteSponsor
     * @request DELETE:/sponsors/{id}
     */
    deleteSponsor: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/sponsors/${id}`,
        method: "DELETE",
        ...params,
      }),
  };
  phases = {
    /**
     * @description Get all phases
     *
     * @tags Phases
     * @name GetPhases
     * @request GET:/phases
     */
    getPhases: (params: RequestParams = {}) =>
      this.request<PhaseResponse[], any>({
        path: `/phases`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new phase
     *
     * @tags Phases
     * @name CreatePhase
     * @request POST:/phases
     */
    createPhase: (
      data: CreateOrUpdatePhaseRequest,
      params: RequestParams = {},
    ) =>
      this.request<PhaseResponse, any>({
        path: `/phases`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get a phase by id
     *
     * @tags Phases
     * @name GetPhase
     * @request GET:/phases/{id}
     */
    getPhase: (id: string, params: RequestParams = {}) =>
      this.request<PhaseResponse, any>({
        path: `/phases/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Update a phase
     *
     * @tags Phases
     * @name UpdatePhase
     * @request PUT:/phases/{id}
     */
    updatePhase: (
      id: string,
      data: CreateOrUpdatePhaseRequest,
      params: RequestParams = {},
    ) =>
      this.request<PhaseResponse, any>({
        path: `/phases/${id}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete a phase
     *
     * @tags Phases
     * @name DeletePhase
     * @request DELETE:/phases/{id}
     */
    deletePhase: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/phases/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Get standings for a specific phase
     *
     * @tags Phases
     * @name GetPhaseStandings
     * @request GET:/phases/{id}/standings
     */
    getPhaseStandings: (id: string, params: RequestParams = {}) =>
      this.request<PoolStanding[], any>({
        path: `/phases/${id}/standings`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Create a playoff phase linked to another phase
     *
     * @tags Phases
     * @name CreatePlayoffPhase
     * @request POST:/phases/create-playoff
     */
    createPlayoffPhase: (
      data: CreatePlayoffPhaseRequest,
      params: RequestParams = {},
    ) =>
      this.request<PhaseResponse, any>({
        path: `/phases/create-playoff`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Create placeholder games for a playoff phase
     *
     * @tags Phases
     * @name CreatePlaceholderGames
     * @request POST:/phases/{id}/create-placeholder-games
     */
    createPlaceholderGames: (id: string, params: RequestParams = {}) =>
      this.request<PhaseResponse, any>({
        path: `/phases/${id}/create-placeholder-games`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Phases
     * @name GeneratePhaseGames
     * @request POST:/phases/{id}/generate-games
     */
    generatePhaseGames: (id: string, params: RequestParams = {}) =>
      this.request<
        {
          error?: string;
          /** @format double */
          gamesCreated: number;
          success: boolean;
        },
        any
      >({
        path: `/phases/${id}/generate-games`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * @description Manually assign teams to a playoff phase from its linked phase
     *
     * @tags Phases
     * @name AssignTeamsToPlayoff
     * @request POST:/phases/{id}/assign-teams
     */
    assignTeamsToPlayoff: (id: string, params: RequestParams = {}) =>
      this.request<PhaseResponse, any>({
        path: `/phases/${id}/assign-teams`,
        method: "POST",
        format: "json",
        ...params,
      }),
  };
  persons = {
    /**
     * @description Get all persons for a specific config with pagination
     *
     * @tags Persons
     * @name GetPersons
     * @request GET:/persons
     */
    getPersons: (
      query?: {
        /** @format double */
        page?: number;
        /** @format double */
        limit?: number;
        sortBy?: string;
        sortOrder?: "asc" | "desc";
        search?: string;
        role?: string;
        team?: string;
        status?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedResponseGetPersonResponse, any>({
        path: `/persons`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new person
     *
     * @tags Persons
     * @name CreatePerson
     * @request POST:/persons
     */
    createPerson: (data: CreatePerson, params: RequestParams = {}) =>
      this.request<GetPersonResponse, any>({
        path: `/persons`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete multiple persons
     *
     * @tags Persons
     * @name DeletePersons
     * @request DELETE:/persons
     */
    deletePersons: (data: string[], params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/persons`,
        method: "DELETE",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Get a person by id (scoped to config)
     *
     * @tags Persons
     * @name GetPerson
     * @request GET:/persons/{id}
     */
    getPerson: (id: string, params: RequestParams = {}) =>
      this.request<GetPersonResponse, any>({
        path: `/persons/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Update a person
     *
     * @tags Persons
     * @name UpdatePerson
     * @request PUT:/persons/{id}
     */
    updatePerson: (
      id: string,
      data: UpdatePerson,
      params: RequestParams = {},
    ) =>
      this.request<GetPersonResponse, any>({
        path: `/persons/${id}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete a person
     *
     * @tags Persons
     * @name DeletePerson
     * @request DELETE:/persons/{id}
     */
    deletePerson: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/persons/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Get persons by team (scoped to config)
     *
     * @tags Persons
     * @name GetPersonsByTeam
     * @request GET:/persons/team/{teamId}
     */
    getPersonsByTeam: (teamId: string, params: RequestParams = {}) =>
      this.request<GetPersonResponse[], any>({
        path: `/persons/team/${teamId}`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  manager = {
    /**
     * No description
     *
     * @tags Manager
     * @name GetManager
     * @request GET:/manager
     */
    getManager: (params: RequestParams = {}) =>
      this.request<IManager, any>({
        path: `/manager`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Manager
     * @name CreateManager
     * @request POST:/manager
     */
    createManager: (data: CreateManager, params: RequestParams = {}) =>
      this.request<IManager, any>({
        path: `/manager`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Manager
     * @name UpdateManager
     * @request PUT:/manager
     */
    updateManager: (data: UpdateManager, params: RequestParams = {}) =>
      this.request<IManager, any>({
        path: `/manager`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Manager
     * @name DeleteManager
     * @request DELETE:/manager
     */
    deleteManager: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/manager`,
        method: "DELETE",
        ...params,
      }),
  };
  games = {
    /**
     * @description Get all games
     *
     * @tags Games
     * @name GetGames
     * @request GET:/games
     */
    getGames: (
      query?: {
        phase_id?: string;
        team_id?: string;
        field_id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetGameResponse[], any>({
        path: `/games`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new game
     *
     * @tags Games
     * @name CreateGame
     * @request POST:/games
     */
    createGame: (data: CreateGameRequest, params: RequestParams = {}) =>
      this.request<GetGameResponse, any>({
        path: `/games`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete multiple games
     *
     * @tags Games
     * @name DeleteGames
     * @request DELETE:/games
     */
    deleteGames: (data: string[], params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/games`,
        method: "DELETE",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Get a game by id
     *
     * @tags Games
     * @name GetGame
     * @request GET:/games/{id}
     */
    getGame: (id: string, params: RequestParams = {}) =>
      this.request<GetGameResponse, any>({
        path: `/games/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Update a game
     *
     * @tags Games
     * @name UpdateGame
     * @request PUT:/games/{id}
     */
    updateGame: (
      id: string,
      data: UpdateGameRequest,
      params: RequestParams = {},
    ) =>
      this.request<GetGameResponse, any>({
        path: `/games/${id}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete a game
     *
     * @tags Games
     * @name DeleteGame
     * @request DELETE:/games/{id}
     */
    deleteGame: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/games/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Create multiple games
     *
     * @tags Games
     * @name CreateGames
     * @request POST:/games/bulk
     */
    createGames: (data: CreateGameRequest[], params: RequestParams = {}) =>
      this.request<GetGameResponse[], any>({
        path: `/games/bulk`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Update multiple games
     *
     * @tags Games
     * @name UpdateGames
     * @request POST:/games/bulk-update
     */
    updateGames: (data: UpdateGamesRequest, params: RequestParams = {}) =>
      this.request<GetGameResponse[], any>({
        path: `/games/bulk-update`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  fields = {
    /**
     * @description Get all fields
     *
     * @tags Fields
     * @name GetFields
     * @request GET:/fields
     */
    getFields: (params: RequestParams = {}) =>
      this.request<FieldResponse[], any>({
        path: `/fields`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new field
     *
     * @tags Fields
     * @name CreateField
     * @request POST:/fields
     */
    createField: (data: CreateFieldRequest, params: RequestParams = {}) =>
      this.request<FieldResponse, any>({
        path: `/fields`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get a field by id
     *
     * @tags Fields
     * @name GetField
     * @request GET:/fields/{id}
     */
    getField: (id: string, params: RequestParams = {}) =>
      this.request<FieldResponse, any>({
        path: `/fields/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Update a field
     *
     * @tags Fields
     * @name UpdateField
     * @request PUT:/fields/{id}
     */
    updateField: (
      id: string,
      data: UpdateFieldRequest,
      params: RequestParams = {},
    ) =>
      this.request<FieldResponse, any>({
        path: `/fields/${id}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete a field
     *
     * @tags Fields
     * @name DeleteField
     * @request DELETE:/fields/{id}
     */
    deleteField: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/fields/${id}`,
        method: "DELETE",
        ...params,
      }),
  };
  config = {
    /**
     * @description Get all configs
     *
     * @tags Config
     * @name GetAllConfigs
     * @request GET:/config/all
     */
    getAllConfigs: (params: RequestParams = {}) =>
      this.request<IConfig[], any>({
        path: `/config/all`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Get all configs
     *
     * @tags Config
     * @name GetAllConfigsDebug
     * @request GET:/config/all/debug
     */
    getAllConfigsDebug: (params: RequestParams = {}) =>
      this.request<IConfig[], any>({
        path: `/config/all/debug`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Get a specific config by config_id
     *
     * @tags Config
     * @name GetConfig
     * @request GET:/config/{id}
     */
    getConfig: (id: string, params: RequestParams = {}) =>
      this.request<IConfig, any>({
        path: `/config/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Update a config by config_id
     *
     * @tags Config
     * @name UpdateConfig
     * @request PUT:/config/{id}
     */
    updateConfig: (
      id: string,
      data: PartialOmitIConfigIdOrConfigIdOrCreatedAtOrUpdatedAt,
      params: RequestParams = {},
    ) =>
      this.request<IConfig, any>({
        path: `/config/${id}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete a config by config_id
     *
     * @tags Config
     * @name DeleteConfig
     * @request DELETE:/config/{id}
     */
    deleteConfig: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/config/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Get a specific config by slug
     *
     * @tags Config
     * @name GetConfigBySlug
     * @request GET:/config/slug/{slug}
     */
    getConfigBySlug: (slug: string, params: RequestParams = {}) =>
      this.request<IConfig, any>({
        path: `/config/slug/${slug}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new config
     *
     * @tags Config
     * @name CreateConfig
     * @request POST:/config
     */
    createConfig: (data: CreateConfig, params: RequestParams = {}) =>
      this.request<
        IConfig &
          RequiredIdString & {
            /** @format double */
            __v: number;
          },
        any
      >({
        path: `/config`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Regenerate tenant assets for a config
     *
     * @tags Config
     * @name RegenerateAssets
     * @request POST:/config/{id}/regenerate-assets
     */
    regenerateAssets: (id: string, params: RequestParams = {}) =>
      this.request<
        {
          message: string;
          success: boolean;
        },
        any
      >({
        path: `/config/${id}/regenerate-assets`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * @description Get subscription plan for a config
     *
     * @tags Config
     * @name GetSubscriptionPlan
     * @request GET:/config/{id}/subscription
     */
    getSubscriptionPlan: (id: string, params: RequestParams = {}) =>
      this.request<ISubscriptionPlan, any>({
        path: `/config/${id}/subscription`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Update subscription plan for a config
     *
     * @tags Config
     * @name UpdateSubscriptionPlan
     * @request PUT:/config/{id}/subscription
     */
    updateSubscriptionPlan: (
      id: string,
      data: any,
      params: RequestParams = {},
    ) =>
      this.request<IConfig, any>({
        path: `/config/${id}/subscription`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Handle Stripe webhook for subscription updates
     *
     * @tags Config
     * @name HandleStripeWebhook
     * @request POST:/config/{id}/subscription/stripe-webhook
     */
    handleStripeWebhook: (
      id: string,
      data: {
        cancel_at_period_end?: boolean;
        /** @format double */
        current_period_end: number;
        /** @format double */
        current_period_start: number;
        status: "active" | "canceled" | "past_due" | "unpaid" | "trialing";
        price_id: string;
        customer_id: string;
        subscription_id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<IConfig, any>({
        path: `/config/${id}/subscription/stripe-webhook`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Check feature access for a config
     *
     * @tags Config
     * @name CheckFeatureAccess
     * @request GET:/config/{id}/subscription/check-feature/{feature}
     */
    checkFeatureAccess: (
      id: string,
      feature: string,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          feature: string;
          hasAccess: boolean;
        },
        any
      >({
        path: `/config/${id}/subscription/check-feature/${feature}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Check usage limits for a config
     *
     * @tags Config
     * @name CheckUsageLimits
     * @request GET:/config/{id}/subscription/usage-limits/{resourceType}
     */
    checkUsageLimits: (
      id: string,
      resourceType: string,
      query: {
        /** @format double */
        currentCount: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** @format double */
          current: number;
          /** @format double */
          limit: number;
          allowed: boolean;
        },
        any
      >({
        path: `/config/${id}/subscription/usage-limits/${resourceType}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Get available subscription plans
     *
     * @tags Config
     * @name GetAvailablePlans
     * @request GET:/config/subscription/plans
     */
    getAvailablePlans: (params: RequestParams = {}) =>
      this.request<
        {
          features: {
            mobile_responsive: boolean;
            real_time_updates: boolean;
            payment_collection: boolean;
            on_site_support: boolean;
            custom_tables: boolean;
            multi_day_support: boolean;
            custom_integrations: boolean;
            white_label: boolean;
            api_access: boolean;
            priority_support: boolean;
            custom_branding: boolean;
            advanced_analytics: boolean;
            /** @format double */
            max_games: number;
            /** @format double */
            max_players: number;
            /** @format double */
            max_teams: number;
          };
          plan_type: PlanType;
        }[],
        any
      >({
        path: `/config/subscription/plans`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Get subscription plan pricing information
     *
     * @tags Config
     * @name GetPlanPricing
     * @request GET:/config/subscription/pricing
     */
    getPlanPricing: (params: RequestParams = {}) =>
      this.request<
        {
          national: {
            features: string[];
            /** @format double */
            maxTeams: number;
            /** @format double */
            price: number;
            description: string;
            name: string;
          };
          regional: {
            features: string[];
            /** @format double */
            maxTeams: number;
            /** @format double */
            price: number;
            description: string;
            name: string;
          };
          local: {
            features: string[];
            /** @format double */
            maxTeams: number;
            /** @format double */
            price: number;
            description: string;
            name: string;
          };
          free: {
            features: string[];
            /** @format double */
            maxTeams: number;
            /** @format double */
            price: number;
            description: string;
            name: string;
          };
        },
        any
      >({
        path: `/config/subscription/pricing`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Connect HelloAsso
     *
     * @tags Config
     * @name ConnectHelloAsso
     * @request POST:/config/{id}/helloasso/connect
     */
    connectHelloAsso: (
      id: string,
      data: {
        organization_id: string;
        /** @format double */
        expires_in: number;
        refresh_token: string;
        access_token: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          organization_id?: string;
          /** @format date-time */
          refresh_token_expires_at?: string;
          refresh_token?: string;
          /** @format date-time */
          token_expires_at?: string;
          access_token?: string;
          connected?: boolean;
        },
        any
      >({
        path: `/config/${id}/helloasso/connect`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a backup of the current config
     *
     * @tags Config
     * @name CreateBackup
     * @request POST:/config/{id}/backup
     */
    createBackup: (
      id: string,
      data: CreateBackupRequest,
      params: RequestParams = {},
    ) =>
      this.request<IBackup, any>({
        path: `/config/${id}/backup`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get all backups for a config
     *
     * @tags Config
     * @name GetBackups
     * @request GET:/config/{id}/backups
     */
    getBackups: (id: string, params: RequestParams = {}) =>
      this.request<IBackup[], any>({
        path: `/config/${id}/backups`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Get a specific backup
     *
     * @tags Config
     * @name GetBackup
     * @request GET:/config/backup/{backupId}
     */
    getBackup: (backupId: string, params: RequestParams = {}) =>
      this.request<IBackup, any>({
        path: `/config/backup/${backupId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Delete a backup
     *
     * @tags Config
     * @name DeleteBackup
     * @request DELETE:/config/backup/{backupId}
     */
    deleteBackup: (backupId: string, params: RequestParams = {}) =>
      this.request<
        {
          message: string;
        },
        any
      >({
        path: `/config/backup/${backupId}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * @description Restore a config from backup
     *
     * @tags Config
     * @name RestoreFromBackup
     * @request POST:/config/backup/{backupId}/restore
     */
    restoreFromBackup: (
      backupId: string,
      data: RestoreBackupRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          message: string;
          config_id: string;
        },
        any
      >({
        path: `/config/backup/${backupId}/restore`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Restore backup into current config (overwrites existing data)
     *
     * @tags Config
     * @name RestoreIntoCurrentConfig
     * @request POST:/config/{id}/backup/{backupId}/restore-into
     */
    restoreIntoCurrentConfig: (
      id: string,
      backupId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          message: string;
        },
        any
      >({
        path: `/config/${id}/backup/${backupId}/restore-into`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * @description Get backup statistics
     *
     * @tags Config
     * @name GetBackupStats
     * @request GET:/config/backup/{backupId}/stats
     */
    getBackupStats: (backupId: string, params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/config/backup/${backupId}/stats`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Duplicate a config with selective components
     *
     * @tags Config
     * @name DuplicateConfig
     * @request POST:/config/{id}/duplicate
     */
    duplicateConfig: (
      id: string,
      data: {
        duplicate_sponsors?: boolean;
        duplicate_persons?: boolean;
        duplicate_games?: boolean;
        duplicate_teams?: boolean;
        duplicate_phases?: boolean;
        duplicate_fields?: boolean;
        new_name: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<IConfig, any>({
        path: `/config/${id}/duplicate`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  assets = {
    /**
     * No description
     *
     * @tags Assets
     * @name GetAssetUrl
     * @request GET:/assets
     */
    getAssetUrl: (
      query: {
        key: string;
        /**
         * @format double
         * @default 3600
         */
        expiresIn?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          url: string;
        },
        any
      >({
        path: `/assets`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  };
  ai = {
    /**
     * @description Generate tournament games using AI
     *
     * @tags AI Game Generation, AI Game Scheduling
     * @name GenerateGames
     * @request POST:/ai/generate-games
     */
    generateGames: (data: GenerateGamesRequest, params: RequestParams = {}) =>
      this.request<GenerateGamesResponse, ErrorResponse>({
        path: `/ai/generate-games`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Schedule existing games using AI
     *
     * @tags AI Game Generation, AI Game Scheduling
     * @name ScheduleGames
     * @request POST:/ai/schedule-games
     */
    scheduleGames: (data: ScheduleGamesRequest, params: RequestParams = {}) =>
      this.request<ScheduleGamesResponse, ErrorResponse>({
        path: `/ai/schedule-games`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  actions = {
    /**
     * @description Get all actions
     *
     * @tags Actions
     * @name GetActions
     * @request GET:/actions
     */
    getActions: (params: RequestParams = {}) =>
      this.request<GetActionResponse[], any>({
        path: `/actions`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new action
     *
     * @tags Actions
     * @name CreateAction
     * @request POST:/actions
     */
    createAction: (data: CreateAction, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/actions`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Actions
     * @name GetActionsByGameId
     * @request GET:/actions/game/{gameId}
     */
    getActionsByGameId: (gameId: string, params: RequestParams = {}) =>
      this.request<GetActionResponse[], any>({
        path: `/actions/game/${gameId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Create action for a specific game
     *
     * @tags Actions
     * @name CreateActionForGame
     * @request POST:/actions/game/{gameId}
     */
    createActionForGame: (
      gameId: string,
      data: OmitCreateActionGame,
      params: RequestParams = {},
    ) =>
      this.request<GetActionResponse, any>({
        path: `/actions/game/${gameId}`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get an action by id
     *
     * @tags Actions
     * @name GetAction
     * @request GET:/actions/{id}
     */
    getAction: (id: string, params: RequestParams = {}) =>
      this.request<GetActionResponse, any>({
        path: `/actions/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Update an action
     *
     * @tags Actions
     * @name UpdateAction
     * @request PUT:/actions/{id}
     */
    updateAction: (
      id: string,
      data: PartialCreateAction,
      params: RequestParams = {},
    ) =>
      this.request<GetActionResponse, any>({
        path: `/actions/${id}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete an action
     *
     * @tags Actions
     * @name DeleteAction
     * @request DELETE:/actions/{id}
     */
    deleteAction: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/actions/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Get available action types for creating actions
     *
     * @tags Actions
     * @name GetActionTypes
     * @request GET:/actions/types
     */
    getActionTypes: (params: RequestParams = {}) =>
      this.request<
        {
          description?: string;
          /** @format double */
          points: number;
          type: string;
        }[],
        any
      >({
        path: `/actions/types`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
}
